import Welcome from '@/views/Welcome/index.vue'

const WelcomeRouter = {
  path: '/welcome',
  name: 'Welcome',
  component: Welcome,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default WelcomeRouter
